import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AuthLayout from 'core/layout/AuthLayout';
import LoginBox from '../components/LoginBox';

function LoginPage() {
    const [searchParams] = useSearchParams();
    const redirectUrl = searchParams.get('redirect') || '/';

    return (
        <AuthLayout>
            <LoginBox redirectUrl={redirectUrl} />
        </AuthLayout>
    );
}

export default LoginPage;
